import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
export const ScreenOverlay = ({ overlays }) => {
    if (overlays.length === 0)
        return null;
    return (_jsx(_Fragment, { children: overlays.map((overlay) => (_jsx("div", { className: "fixed z-40 pointer-events-none", style: {
                bottom: `${overlay.position.y}px`,
                right: `${overlay.position.x}px`,
                maxWidth: '20vw', // Max 20% of viewport width
            }, children: _jsx("div", { className: "bg-white rounded-lg shadow-lg p-3 m-2", children: _jsx("img", { src: overlay.imageUrl, alt: overlay.metadata.name || 'Screen Overlay', className: "w-full h-auto rounded", style: { maxHeight: '150px' } }) }) }, overlay.id))) }));
};
